/**
 * 为 true 时：实验室人员中除「教师」外的分类（博士生、硕士生、本科生、毕业学生、访问学者）
 * 列表不拉取接口、始终为空；学生个人介绍页也不再请求内容。
 * 改回 false 可恢复从数据库展示。
 */
export const hideNonProfessorStaffLists = true;
